import { Feature } from '@shinetools/pricing-plan-library';

import { useCurrentPricingPlan } from '../useCurrentPricingPlan';

export const useMultiWalletFeature = () => {
  const { isFeatureAvailable } = useCurrentPricingPlan();

  const isFeatureAvailableForCompanyPlan = isFeatureAvailable(
    Feature.MultiWallet,
  );

  return {
    isMultiWalletFeatureAvailableForCompanyPlan:
      isFeatureAvailableForCompanyPlan,
  };
};
